import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Associations from './pages/Associations';
import CreateAssociation from './pages/CreateAssociation';
import AssociationDetail from './pages/AssociationDetail';
import authService from './services/auth';

function App() {
  const isAuthenticated = authService.isAuthenticated();

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
        />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Associations />
            </ProtectedRoute>
          }
        />
        <Route
          path="/associations/create"
          element={
            <ProtectedRoute>
              <CreateAssociation />
            </ProtectedRoute>
          }
        />
        <Route
          path="/associations/:associationId"
          element={
            <ProtectedRoute>
              <AssociationDetail />
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
